import { render, staticRenderFns } from "./GroupsToolbar.vue?vue&type=template&id=3658e230&"
import script from "./GroupsToolbar.vue?vue&type=script&lang=js&"
export * from "./GroupsToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports